// extracted by mini-css-extract-plugin
module.exports = {"content":"UpdateControlModeModal_content__1HTqK","pinkText":"UpdateControlModeModal_pinkText__RbQzi","bold":"UpdateControlModeModal_bold__1bVnh"};